import { FC } from 'react';

import { HomeSpace, WorkspaceCardMenuAction } from '../../types/data-room.types';
import {
  isVaultSpace,
  spaceCardStats,
  spaceCardStatus,
  spaceDescription,
  spaceLastUpdatedIso,
  toSelectedSpace,
} from '../../utils/space-list-item.util';
import { LastActive } from './last-active';
import { WorkspaceCard } from './workspace-card';

export type CardActionHandler = (action: WorkspaceCardMenuAction, space: HomeSpace) => void;

/** One space of Home as a card: the Vault, a workspace or a data room. */
export const SpaceCard: FC<{
  isDownloading?: boolean;
  onAction?: CardActionHandler;
  onClick?: () => void;
  space: HomeSpace;
}> = ({ isDownloading = false, onAction, onClick, space }) => (
  <WorkspaceCard
    description={spaceDescription(space)}
    isDownloading={isDownloading}
    kind={space.kind}
    lastUpdated={<LastActive at={spaceLastUpdatedIso(space)} />}
    onClick={onClick}
    onMenuAction={onAction && ((action) => onAction(action, space))}
    showMenu={!isVaultSpace(space)}
    stats={spaceCardStats(space)}
    status={spaceCardStatus(toSelectedSpace(space))}
    title={space.name}
  />
);
